export default __webpack_public_path__ + "static/media/Readify.e18001a0.png";